import { httpRequest } from "@services/http";
import type { LaunchNetworkConfig } from "@models/launchNetwork.model";
import { LaunchNetworkConfigSerializer } from "@models/serializers/launchNetworkSerializer";

export class CommandGetLaunchNetworks {
  async run(launchId: number): Promise<LaunchNetworkConfig[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/networks/`;
    const response = await httpRequest<any[]>(url, { method: "GET" });

    const serializer = new LaunchNetworkConfigSerializer();
    return serializer.deserializeList(response);
  }
}